/* ============================================
   FUNTIVITY TOYS — Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile Menu Toggle ---- */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      const spans = hamburger.querySelectorAll('span');
      hamburger.classList.toggle('active');
    });
  }

  /* ---- Quantity Buttons ---- */
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const wrap = this.closest('.qty-wrap');
      const input = wrap.querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'inc') val = Math.min(val + 1, 99);
      if (this.dataset.action === 'dec') val = Math.max(val - 1, 1);
      input.value = val;

      // On the cart page, each quantity control lives inside its own
      // '/cart/change' form. The buttons only updated the number shown
      // in the box — they never told Shopify's cart about the change,
      // which is why totals stayed stuck at the old quantity. Submitting
      // the form here actually applies the change.
      const cartForm = this.closest('form[action="/cart/change"]');
      if (cartForm) {
        cartForm.submit();
      }
    });
  });

  /* ---- Manual quantity typing on the cart page ---- */
  document.querySelectorAll('form[action="/cart/change"] .qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      let val = parseInt(this.value) || 0;
      if (val < 0) val = 0;
      this.value = val;
      this.closest('form').submit();
    });
  });

  /* ---- Smooth Scroll for anchor links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- Add to Cart feedback ---- */
  const atcBtns = document.querySelectorAll('.btn-add-to-cart, .btn-atc-full');
  atcBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const orig = this.textContent;
      this.textContent = '✓ Added!';
      this.style.background = '#00B894';
      const self = this;
      setTimeout(function () {
        self.textContent = orig;
        self.style.background = '';
      }, 2000);
    });
  });

  /* ---- Share button (native share sheet, or copy link as fallback) ---- */
  document.querySelectorAll('.btn-share').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const url = this.dataset.shareUrl || window.location.href;
      const title = this.dataset.shareTitle || document.title;
      const self = this;
      const origHTML = self.innerHTML;

      function showCopied() {
        self.innerHTML = '✓ Link Copied!';
        setTimeout(function () { self.innerHTML = origHTML; }, 2000);
      }

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {
          /* user cancelled share sheet — no action needed */
        });
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(showCopied).catch(function () {
          window.prompt('Copy this link:', url);
        });
      } else {
        window.prompt('Copy this link:', url);
      }
    });
  });

  /* ---- Product media gallery (slidable) ---- */
  document.querySelectorAll('.product-gallery').forEach(function (root) {
    const track = root.querySelector('.gallery-main-track');
    const slides = Array.prototype.slice.call(root.querySelectorAll('.gallery-slide'));
    const thumbs = Array.prototype.slice.call(root.querySelectorAll('.gallery-thumb'));
    const prevBtn = root.querySelector('.gallery-arrow-prev');
    const nextBtn = root.querySelector('.gallery-arrow-next');
    let current = 0;

    function goTo(index) {
      const total = slides.length;
      index = ((index % total) + total) % total;
      const oldSlide = slides[current];
      if (oldSlide) {
        oldSlide.querySelectorAll('video').forEach(function (v) { v.pause(); });
      }
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      slides.forEach(function (s, i) { s.classList.toggle('active', i === current); });
      thumbs.forEach(function (t, i) { t.classList.toggle('active', i === current); });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    /* Swipe support for touch devices */
    let startX = 0;
    let isTouching = false;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      isTouching = true;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!isTouching) return;
      isTouching = false;
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current - 1 : current + 1);
      }
    }, { passive: true });

    /* Keyboard arrow support when gallery is focused */
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  /* ---- Gallery autoplay slideshow ---- */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.product-gallery').forEach(function (root) {
    var slides = root.querySelectorAll('.gallery-slide');
    var next = root.querySelector('.gallery-arrow-next');
    if (slides.length < 2 || !next) return;
    var paused = false;
    var resumeTimer;
    function playingVideo() {
      return Array.prototype.some.call(root.querySelectorAll('video'), function (v) { return !v.paused && !v.ended; });
    }
    setInterval(function () {
      if (paused || document.hidden || playingVideo()) return;
      next.click();
    }, 4000);
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('touchstart', function () {
      paused = true;
      clearTimeout(resumeTimer);
    }, { passive: true });
    root.addEventListener('touchend', function () {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, 8000);
    }, { passive: true });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  /* ---- Gallery: autoplay video slide (muted) and advance when it ends ---- */
  document.querySelectorAll('.product-gallery').forEach(function (root) {
    var next = root.querySelector('.gallery-arrow-next');
    var slides = root.querySelectorAll('.gallery-slide');
    if (!next || slides.length < 2) return;
    slides.forEach(function (s) {
      var v = s.querySelector('video');
      if (!v) return;
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.playsInline = true;
      v.preload = 'auto';
      v.addEventListener('ended', function () {
        if (s.classList.contains('active')) next.click();
      });
      new MutationObserver(function () {
        if (s.classList.contains('active')) {
          v.currentTime = 0;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      }).observe(s, { attributes: true, attributeFilter: ['class'] });
    });
  });
});

/* ---- Discourage image/video downloads (right-click, drag, long-press, video download button) ---- */
(function () {
  var s = document.createElement('style');
  s.textContent = 'img,video{-webkit-user-drag:none;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none;}';
  document.head.appendChild(s);
  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest && e.target.closest('img,video,picture')) e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') e.preventDefault();
  });
  function lock() {
    document.querySelectorAll('img').forEach(function (i) { i.setAttribute('draggable', 'false'); });
    document.querySelectorAll('video').forEach(function (v) {
      v.setAttribute('controlsList', 'nodownload noremoteplayback');
      v.setAttribute('disablePictureInPicture', '');
    });
  }
  document.addEventListener('DOMContentLoaded', lock);
})();


/* ===== Tihar decorations ===== */
(function () {
  if (document.getElementById('tihar-deco')) return;
  var ann = document.querySelector('.announcement-bar');
  if (!ann || !ann.parentNode) return;
  var cols = ['#ff4d6d', '#ffd43b', '#ff922b', '#f06595', '#69db7c', '#4dabf7'];
  var deco = document.createElement('div');
  deco.id = 'tihar-deco';
  deco.className = 'tihar-deco';
  deco.setAttribute('aria-hidden', 'true');

  var lights = document.createElement('div');
  lights.className = 'ti-lights';
  deco.appendChild(lights);

  function drawLights() {
    var w = document.documentElement.clientWidth, seg = 56, n = Math.ceil(w / seg);
    var p = 'M0 0', b = '';
    for (var i = 0; i < n; i++) {
      var x0 = i * seg, bx = x0 + seg / 2, c = cols[i % cols.length];
      p += ' Q' + bx + ' 18 ' + (x0 + seg) + ' 0';
      b += '<g class="ti-bulb" style="color:' + c + ';animation-delay:' + ((i % 6) * 0.3) + 's">' +
        '<rect x="' + (bx - 2) + '" y="7" width="4" height="5" rx="1" fill="#5a3a22"/>' +
        '<ellipse cx="' + bx + '" cy="17" rx="4.5" ry="6.5" fill="' + c + '"/></g>';
    }
    lights.innerHTML = '<svg viewBox="0 0 ' + (n * seg) + ' 30" preserveAspectRatio="xMinYMin slice"><path d="' + p + '" fill="none" stroke="#5a3a22" stroke-width="1.5"/>' + b + '</svg>';
  }
  drawLights();
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(drawLights, 200); });

  function strand(cls, len) {
    var s = '<svg class="ti-strand ' + cls + '" viewBox="0 0 46 ' + (len + 26) + '"><line x1="23" y1="0" x2="23" y2="' + len + '" stroke="#7a4b1e" stroke-width="1.5"/>';
    var k = 0;
    for (var y = 10; y < len; y += 15, k++) {
      var c = k % 2 ? '#ffbf00' : '#ff8a00';
      s += '<circle cx="23" cy="' + y + '" r="9" fill="' + c + '"/><circle cx="23" cy="' + y + '" r="4" fill="#d9480f" opacity=".55"/>';
    }
    s += '<path d="M23 ' + (len + 2) + ' l-6 22 h12z" fill="#be2870"/><circle cx="23" cy="' + (len + 2) + '" r="5" fill="#ffd43b"/></svg>';
    return s;
  }
  var g = document.createElement('div');
  g.innerHTML = strand('l1', 150) + strand('l2', 100) + strand('r1', 130) + strand('r2', 90);
  while (g.firstChild) deco.appendChild(g.firstChild);

  var r = '<svg class="ti-rangoli" viewBox="-100 -100 200 200">';
  for (var i = 0; i < 12; i++) r += '<ellipse cx="0" cy="-62" rx="13" ry="32" fill="none" stroke="' + cols[i % 6] + '" stroke-width="3" transform="rotate(' + (i * 30) + ')"/>';
  for (i = 0; i < 8; i++) r += '<ellipse cx="0" cy="-32" rx="9" ry="20" fill="' + cols[(i + 2) % 6] + '" opacity=".8" transform="rotate(' + (i * 45) + ')"/>';
  for (i = 0; i < 24; i++) r += '<circle cx="0" cy="-92" r="3" fill="#ffd43b" transform="rotate(' + (i * 15) + ')"/>';
  r += '<circle r="10" fill="#d9480f"/><circle r="4" fill="#ffd43b"/></svg>';
  var rg = document.createElement('div');
  rg.innerHTML = r;
  deco.appendChild(rg.firstChild);
  ann.parentNode.insertBefore(deco, ann.nextSibling);

  function diya(cls, id) {
    return '<svg class="ti-diya ' + cls + '" viewBox="0 0 60 56">' +
      '<defs><radialGradient id="tg' + id + '"><stop offset="0" stop-color="#ffd43b" stop-opacity=".9"/><stop offset="1" stop-color="#ff922b" stop-opacity="0"/></radialGradient>' +
      '<linearGradient id="tf' + id + '" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stop-color="#ff6b00"/><stop offset="1" stop-color="#ffe066"/></linearGradient></defs>' +
      '<circle class="ti-glow" cx="30" cy="16" r="22" fill="url(#tg' + id + ')"/>' +
      '<path class="ti-flame" d="M30 26 C20 16 27 7 30 0 C33 7 40 16 30 26Z" fill="url(#tf' + id + ')"/>' +
      '<path d="M4 28 Q30 58 56 28 Q30 34 4 28Z" fill="#b5470c"/>' +
      '<ellipse cx="30" cy="28" rx="26" ry="4.5" fill="#d9480f"/>' +
      '<path d="M12 36 Q30 46 48 36" fill="none" stroke="#ffd43b" stroke-width="1.5" stroke-dasharray="2 3"/></svg>';
  }
  var dw = document.createElement('div');
  dw.innerHTML = diya('dl', 'a') + diya('dr', 'b');
  while (dw.firstChild) document.body.appendChild(dw.firstChild);

  var sp = document.createElement('div');
  sp.className = 'ti-sparkles';
  sp.setAttribute('aria-hidden', 'true');
  var sh = '';
  for (i = 0; i < 16; i++) {
    sh += '<span style="left:' + Math.round(Math.random() * 96) + '%;font-size:' + (10 + Math.round(Math.random() * 12)) + 'px;animation-duration:' + (9 + Math.round(Math.random() * 8)) + 's;animation-delay:-' + Math.round(Math.random() * 14) + 's">&#10022;</span>';
  }
  sp.innerHTML = sh;
  document.body.appendChild(sp);
})();


/* ===== Tihar: floating diyas + fireworks ===== */
(function () {
  var old = document.querySelector('.ti-sparkles');
  if (old) old.remove();
  if (document.getElementById('ti-float')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var small = window.innerWidth < 640;
  var L = document.createElement('div');
  L.id = 'ti-float';
  L.className = 'ti-float';
  L.setAttribute('aria-hidden', 'true');
  var n = small ? 5 : 9, h = '';
  for (var i = 0; i < n; i++) {
    h += '<svg class="ti-fd" viewBox="0 0 60 56" style="left:' + (4 + Math.round(Math.random() * 90)) + '%;width:' + (24 + Math.round(Math.random() * 14)) + 'px;animation-duration:' + (16 + Math.round(Math.random() * 12)) + 's;animation-delay:-' + Math.round(Math.random() * 20) + 's">' +
      '<circle class="ti-glow" cx="30" cy="16" r="22" fill="url(#tga)"/>' +
      '<path class="ti-flame" d="M30 26 C20 16 27 7 30 0 C33 7 40 16 30 26Z" fill="url(#tfa)"/>' +
      '<path d="M4 28 Q30 58 56 28 Q30 34 4 28Z" fill="#b5470c"/>' +
      '<ellipse cx="30" cy="28" rx="26" ry="4.5" fill="#d9480f"/></svg>';
  }
  L.innerHTML = h;
  document.body.appendChild(L);

  var cols = ['#ffd43b', '#ff6b6b', '#f783ac', '#69db7c', '#4dabf7', '#ff922b', '#ffffff'];
  function pick() { return cols[Math.floor(Math.random() * cols.length)]; }
  function burst(x, y) {
    var c1 = pick(), c2 = pick();
    var w = document.createElement('div');
    w.className = 'ti-fw';
    w.style.left = x + 'px';
    w.style.top = y + 'px';
    var k = small ? 14 : 22, s = '';
    for (var j = 0; j < k; j++) {
      var a = j / k * 6.2832, d = 50 + Math.random() * 40;
      s += '<i style="--x:' + Math.round(Math.cos(a) * d) + 'px;--y:' + Math.round(Math.sin(a) * d) + 'px;--c:' + (j % 2 ? c1 : c2) + '"></i>';
    }
    w.innerHTML = s;
    document.body.appendChild(w);
    setTimeout(function () { w.remove(); }, 1700);
  }
  function launch() {
    if (document.hidden) return;
    var x = Math.round(60 + Math.random() * (window.innerWidth - 120));
    var y = Math.round(110 + Math.random() * (window.innerHeight * 0.35));
    var r = document.createElement('div');
    r.className = 'ti-rk';
    r.style.left = x + 'px';
    r.style.top = window.innerHeight + 'px';
    document.body.appendChild(r);
    var a = r.animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(' + (y - window.innerHeight) + 'px)', opacity: 1 }], { duration: 800, easing: 'ease-out' });
    a.onfinish = function () { r.remove(); burst(x, y); };
  }
  setTimeout(launch, 1200);
  setInterval(launch, 3200);
})();


/* ===== Tihar: remove floating diyas, more firework styles ===== */
(function () {
  var f = document.getElementById('ti-float');
  if (f) f.remove();
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.getElementById('ti-fx-style')) return;
  var st = document.createElement('style');
  st.id = 'ti-fx-style';
  st.textContent = '.ti-fw i{animation-delay:var(--d,0s);animation-fill-mode:both}' +
    '.ti-fw i.w{animation-name:ti-willow;animation-duration:2.6s;animation-timing-function:ease-out}' +
    '.ti-fw i.t{width:3px;height:3px;animation-name:ti-twinkle2;animation-duration:1.6s}' +
    '.ti-fw i.b{width:7px;height:7px;margin:-3px 0 0 -3px}' +
    '@keyframes ti-willow{0%{transform:translate(0,0);opacity:1}55%{transform:translate(var(--x),var(--y));opacity:1}100%{transform:translate(var(--x),calc(var(--y) + 70px));opacity:0}}' +
    '@keyframes ti-twinkle2{0%{transform:translate(0,0);opacity:0}15%{opacity:1}35%{opacity:.2}55%{opacity:1}100%{transform:translate(var(--x),var(--y));opacity:0}}';
  document.head.appendChild(st);

  var small = window.innerWidth < 640;
  var cols = ['#ffd43b', '#ff6b6b', '#f783ac', '#69db7c', '#4dabf7', '#ff922b', '#ffffff', '#e599f7'];
  function pick() { return cols[Math.floor(Math.random() * cols.length)]; }
  var sc = small ? 0.7 : 1;

  function pts(type) {
    var a = [], i, k, t, r;
    if (type === 'ring') {
      k = 26; for (i = 0; i < k; i++) { t = i / k * 6.2832; a.push([Math.cos(t) * 80, Math.sin(t) * 80, 0, '', 0]); }
    } else if (type === 'double') {
      for (i = 0; i < 12; i++) { t = i / 12 * 6.2832; a.push([Math.cos(t) * 38, Math.sin(t) * 38, 0, 'b', 0]); }
      for (i = 0; i < 24; i++) { t = i / 24 * 6.2832 + 0.13; a.push([Math.cos(t) * 90, Math.sin(t) * 90, 0.12, '', 1]); }
    } else if (type === 'willow') {
      for (i = 0; i < 30; i++) { t = i / 30 * 6.2832; r = 55 + Math.random() * 35; a.push([Math.cos(t) * r, Math.sin(t) * r, 0, 'w', 0]); }
    } else if (type === 'heart') {
      for (i = 0; i < 30; i++) { t = i / 30 * 6.2832; a.push([5 * 16 * Math.pow(Math.sin(t), 3), -5 * (13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t)) * 0.95, 0, 'b', 0]); }
    } else if (type === 'star') {
      for (i = 0; i < 5; i++) { t = i / 5 * 6.2832 - 1.5708; for (k = 1; k <= 5; k++) { a.push([Math.cos(t) * k * 18, Math.sin(t) * k * 18, k * 0.04, k === 5 ? 'b' : '', 0]); } }
    } else if (type === 'spiral') {
      for (i = 0; i < 36; i++) { t = i * 0.55; r = 8 + i * 2.4; a.push([Math.cos(t) * r, Math.sin(t) * r, i * 0.03, '', 0]); }
    } else if (type === 'crackle') {
      for (i = 0; i < 40; i++) { t = Math.random() * 6.2832; r = 30 + Math.random() * 70; a.push([Math.cos(t) * r, Math.sin(t) * r, Math.random() * 0.8, 't', Math.random() > 0.5 ? 1 : 0]); }
    }
    return a;
  }

  function burst(type, x, y) {
    var c1 = pick(), c2 = pick(), p = pts(type);
    if (small) p = p.filter(function (_, i) { return i % 2 === 0; });
    var w = document.createElement('div');
    w.className = 'ti-fw';
    w.style.left = x + 'px';
    w.style.top = y + 'px';
    var s = '';
    for (var i = 0; i < p.length; i++) {
      var q = p[i], c = type === 'willow' ? '#ffcf4a' : (q[4] ? c2 : c1);
      s += '<i class="' + q[3] + '" style="--x:' + Math.round(q[0] * sc) + 'px;--y:' + Math.round(q[1] * sc) + 'px;--c:' + c + ';--d:' + q[2] + 's"></i>';
    }
    w.innerHTML = s;
    document.body.appendChild(w);
    setTimeout(function () { w.remove(); }, 3200);
  }

  var types = ['ring', 'double', 'willow', 'heart', 'star', 'spiral', 'crackle'], last = '';
  function launch() {
    if (document.hidden) return;
    var type; do { type = types[Math.floor(Math.random() * types.length)]; } while (type === last);
    last = type;
    var x = Math.round(110 + Math.random() * (window.innerWidth - 220));
    var y = Math.round(130 + Math.random() * (window.innerHeight * 0.3));
    var r = document.createElement('div');
    r.className = 'ti-rk';
    r.style.left = x + 'px';
    r.style.top = window.innerHeight + 'px';
    document.body.appendChild(r);
    var an = r.animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(' + (y - window.innerHeight) + 'px)', opacity: 1 }], { duration: 750, easing: 'ease-out' });
    an.onfinish = function () { r.remove(); burst(type, x, y); };
  }
  setTimeout(launch, 2200);
  setInterval(launch, 2600);
})();
